import api from 'services/api.service';

const uploadDocument = (formData) => api.post('/signnow/document', formData);

const getDocument = ({ signDocumentId }) => api.get(`/signnow/document/${signDocumentId}`);

const getDocumentsByGroupId = ({ documentGroupId }) => api.get(`/signnow/documents/${documentGroupId}`);

const updateDocument = ({ signDocumentId, body }) => api.put(`/signnow/document/${signDocumentId}`, body);

// upload template
const uploadTemplate = (formData) => api.post('/signnow/template', formData);

// get available company templates
const getCompanyTemplates = () => api.get('/signnow/template');

// update template fields
const updateTemplateFields = ({ templateId, fields }) => api.put(
  '/signnow/template',
  { templateId, fields },
);

// delete signnow document with all relations
const deleteDocument = ({ signDocumentId }) => api.delete(
  `/signnow/template/${signDocumentId}`,
);

const downloadDocument = ({ signDocumentId }) => api.get(
  `/signnow/document/${signDocumentId}/download`,
);

const attachToListedkit = ({ documentId, listedkitId }) => api.post(
  '/signnow/template/attach-to-listedkit',
  { documentId, listedkitId },
);

const detachFromListedkit = ({ documentId, listedkitId }) => api.post(
  '/signnow/template/detach-from-listedkit',
  { documentId, listedkitId },
);

const getTransactionDocuments = ({ dealId }) => api.get(
  '/signnow/transaction-documents',
  { dealId },
);

const getPublicTransactionDocuments = ({ dealId }) => api.get(
  '/signnow/public/transaction-documents',
  { dealId },
);

const getDocumentsByDealIds = ({ dealIds }) => api.get(
  '/signnow/documents-by-deal-ids',
  { dealIds },
);

const getAttachedSignDocuments = ({ listedkitId }) => api.get(
  '/signnow/template/attached-to-kit',
  { listedkitId },
);

const createTransactionDocuments = ({ documentIds, listedKitId, dealId }) => api.post(
  '/signnow/create-transaction-documents',
  { templateIds: documentIds, listedKitId, dealId },
);

const sendReminder = ({ dealId, emails }) => api.post(
  '/signnow/send-reminder',
  { dealId, emails },
);

const cancelInvites = ({ eSignDocumentId }) => api.delete(
  `/signnow/cancel-invites/${eSignDocumentId}`,
);

const cancelDocGroupInvites = ({ documentGroupId }) => api.delete(
  `/signnow/cancel-invites/doc-group/${documentGroupId}`,
);

const getViewDocumentLink = ({ documentId }) => api.get(`/signnow/document/${documentId}/view-link`);

export {
  uploadDocument,
  getDocument,
  getDocumentsByGroupId,
  updateDocument,
  uploadTemplate,
  getCompanyTemplates,
  getAttachedSignDocuments,
  getTransactionDocuments,
  getPublicTransactionDocuments,
  getDocumentsByDealIds,
  attachToListedkit,
  detachFromListedkit,
  deleteDocument,
  downloadDocument,
  createTransactionDocuments,
  updateTemplateFields as updateTemplate,
  cancelInvites,
  cancelDocGroupInvites,
  sendReminder,
  getViewDocumentLink,
};
